// invite.js
import selfHtml from './s20-invite.html' with { type: 'text' };;

import { postData, showOffcanvas, navbar_active_menu } from "../utils.js";

import { mod_loader, BASEURL, ShareModule, PubkeySelfModule } from "../AppState.js"

import { get_pub_key } from "../crypt_helper.js";

var active_link = null;

var root

export async function init(module_root) {

    module_root.innerHTML = selfHtml;

    root = module_root

    root.querySelector(".btn_show_self_key").addEventListener('click', () => mod_loader(PubkeySelfModule));

    const description_why_to_shate = "Hi, please find the link to my public encryption key below. \n\n" +
        "Use this key to send me encrypted messages, ensuring that your communications remain secure " +
        "even if my email is being monitored.\n ";

    const pub_key = await get_pub_key();

    if (pub_key == null) {
        showOffcanvas('offcanvasAddkeyPanel', async () => {
            init(root);
        });
        return;
    }


    navbar_active_menu(".share_connect")

    const url = new URL(window.location)

    const WWW_BASEURL = url.origin + url.pathname;

    if (active_link == null) {
        const data = await postData(BASEURL.api + '/pubkey', { pgp_pubkey: pub_key.myKeyPairPublicKey });
        active_link = `${WWW_BASEURL}?pubk=${encodeURIComponent(data.hash)}`;
    }

    const shareData = {
        title: "Connect PGP encryption key",
        text: description_why_to_shate,
        url: active_link
    };

    mod_loader(ShareModule, { target: ".div_share_methods_section", active_link, shareData });
}

// ----
